import { Box, Icon, Spinner, Text } from '@factorialco/deprecated-design-system'

import { Action, ButtonType } from '../_PageHeader/_Actions'
import * as styles from './index.vanilla.css'

export interface TransactionalActions {
  primary: Action
  secondary?: Action
  status?: {
    text: string
  } & (
    | {
        icon: React.ComponentProps<typeof Icon.Medium>['icon']
        loading?: never
      }
    | { loading: boolean; icon?: never }
  )
}

export const TransactionalActions: React.FC<{ data: TransactionalActions }> = ({ data }) => {
  return (
    <Box
      className={styles.transactionalActions}
      width="full"
      justifyContent="spaceBetween"
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      gap="s8"
    >
      <Box flexDirection="row" alignItems="center" gap="s4">
        {data?.status?.icon && (
          <Box width="s24">
            <Icon.Medium icon={data?.status?.icon} />
          </Box>
        )}
        {data?.status?.loading && (
          <Box width="s24">
            <Spinner size="s16" />
          </Box>
        )}
        <Text.Normal size="200">{data?.status?.text}</Text.Normal>
      </Box>
      {(data?.primary || data?.secondary) && (
        <Box flexDirection="row" gap="s8" justifyContent="flexEnd" flexGrow>
          {data?.secondary && (
            <ButtonType action={data?.secondary} variant={'secondary'}>
              {data?.secondary.label}
            </ButtonType>
          )}
          {data?.primary && (
            <ButtonType action={data?.primary} variant={'primary'}>
              {data?.primary.label}
            </ButtonType>
          )}
        </Box>
      )}
    </Box>
  )
}
